/* istanbul ignore file */
import { combineReducers } from 'redux'

import {
    CONTRACT_RENTAL_CAR,
    RECEIVE_RENTAL_CAR_CONTRACT,
    REQUEST_RENTAL_CAR_CONTRACT,
} from '../actions/types'

const initialState = {
    status: {
        loaded: false,
        pending: false,
        error: null,
    },
    data: null,
}

function dataReducer (state = initialState.data, action) {
    switch (action.type) {
        case RECEIVE_RENTAL_CAR_CONTRACT:
            if (action.status.error) {
                return initialState.data
            }

            return { ...action.rentalCarContract }
        default:
            return state
    }
}

function statusReducer (state = initialState.status, action) {
    switch (action.type) {
        case CONTRACT_RENTAL_CAR:
            return {
                pending: true,
                loaded: false,
                error: null,
            }
        case REQUEST_RENTAL_CAR_CONTRACT:
            return {
                pending: true,
                loaded: false,
                error: null,
            }
        case RECEIVE_RENTAL_CAR_CONTRACT:
            return {
                pending: false,
                loaded: true,
                error: action.status.error,
            }
        default:
            return state
    }
}

export default combineReducers({
    data: dataReducer,
    status: statusReducer,
})
